module.exports = __webpack_public_path__ + "img/pearl.164ff7e8.jpg";